import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getApiUrl, apiList } from 'src/app/core/Constants/apiList';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';
import { UserProfile } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationsService {

  public user: UserProfile | null;
  public activeTab = 0;

  constructor(private http: HttpClient,
    private userService: UserService) {
    this.user = this.userService.getUserInfo();
  }

  public getPreApprovalList(filterPayload: Record<string, string | number | null>, id: number): Observable<ApiResponse> {
    const endpoint = getApiUrl(apiList.authorization.getPreApprovalTransactionList, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint)
  }

  public getPreApprovalListCommon(filterPayload: Record<string, string | number | null>, id: number): Observable<ApiResponse> {
    const endpoint = getApiUrl(apiList.authorization.getPreApprovalTransactionListCommon, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint)
  }

  public getPreApprovalListByPayer(filterPayload: Record<string, string | number | null>, id: number): Observable<ApiResponse> {
    const endpoint = getApiUrl(apiList.authorization.preApprovalPayerList, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint);
  }

  public getPreApprovalListByProvider(filterPayload: Record<string, string | number | null>, id: number): Observable<ApiResponse> {
    const endpoint = getApiUrl(apiList.authorization.getPreApprovalProviderList, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint);
  }

  public getPreApprovalDetails(id: number): Observable<ApiResponse> {
    const endpoint = getApiUrl(apiList.authorization.getPreApprovalTransactionDetails, null, { id });
    return this.http.get<ApiResponse>(endpoint);
  }

  public setApprovalStatus(id: number, payLoad: Record<string, string | number>): Observable<ApiResponse> {
    const endpoint = getApiUrl(apiList.authorization.setPreApprovalStatus, null, { id });
    return this.http.put<ApiResponse>(endpoint, payLoad)
  }

  public getPreApprovalLabList(id: number, filterPayload: Record<string, string | number | null>): Observable<ApiResponse> {
    const endpoint = getApiUrl(apiList.authorization.getPreApprovalLabList, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint);
  }

  public getPreApprovalRadList(id: number, filterPayload: Record<string, string | number | null>): Observable<ApiResponse> {
    const endpoint = getApiUrl(apiList.authorization.getPreApprovalRadList, filterPayload, { id });
    return this.http.get<ApiResponse>(endpoint);
  }
}
